import Light from "../composition/Light";
import Cluster, { ClusterElement } from "../composition/Cluster";
import { DomainModelData, DomainModelsData } from "../composition/composition";
import Pendant from "../composition/Pendant";
import { ComposableElement } from "../composition/Group";
import Base from "../composition/Base";
import VibiaFactory from "./VibiaFactory";
export const pendantLocation = 4
const tableLocation = 12

export type Luminary = Base


export default class Luminaries {
    static createLuminary(data: DomainModelData): Luminary {
        return VibiaFactory.createElement(data)
    }

    static createLuminaryByReference(data: DomainModelData, reference: String): Luminary {
        const myCluster = Luminaries.createLuminary(data)
        let light = myCluster.getLights()[0].element
        light = light.setAttributesByReference(reference)
        return light.getParent()
    }

    static createLuminaries(data: DomainModelsData) {
        Luminaries.checkDataExist(data);
        let luminaries: { [key: string]: Luminary } = {};
        Object.entries(data).forEach(([key, element]) => luminaries[key] = this.createLuminary(element));
        return luminaries;
    }

    private static checkDataExist(data: any) {
        if (!data) {
            throw 'Required data to define domain was not provided';
        }
    }

    // FIXME: Metodo temporal (basicamente para mantener retrocompatibilidad), para no tener duplicidad de obtencion de una light en funcion de una Luminary por todo el codigo (Hace falta plantear como solventar cuando se quiere una light)
    static getLight(data: DomainModelData): Light | Pendant {
        const luminary = Luminaries.createLuminary(data)
        return Array.isArray(luminary.getLights())
            ? (luminary.getLights() as ClusterElement[])[0].element as Light
            : (luminary.getLights() as ComposableElement).element as Light
    }
}
